<ng-container *ngIf="!hide">
  <app-sidebar></app-sidebar>
  <!-- Start Main Content Wrapper Area -->
  <div class="main-content d-flex flex-column">
    <app-header></app-header>
    <app-idle-modal></app-idle-modal>
    <router-outlet></router-outlet>
    <div class="flex-grow-1"></div>
    <app-footer></app-footer>
  </div>
</ng-container>

<ng-container *ngIf="hide">
  <router-outlet></router-outlet>
</ng-container>